/**
 * The wound tables — built and validated once, at module load.
 *
 * `WoundTable.from` checks every cell here: six levels per `(type, zone)`,
 * non-negative numbers, known effects, at least two narration templates, and
 * no typo'd `{token}`. A hole in the tables therefore fails on import, not on
 * the ten-thousandth duel of an overnight balance run.
 *
 * Note what is *not* checked here: whether the tables cover everything the
 * world can actually do to a body. That question needs the body plans and the
 * attack profiles as well, so `assertTableCovers` answers it in
 * `content.test.ts` — and it will start failing the day somebody adds a
 * creature with a zone nobody wrote entries for, which is exactly when it
 * should.
 */
import { WoundTable } from '@annwn/sim';
import { BITE_OVERLAY } from './bite.js';
import { BLUNT_TABLE } from './blunt.js';
import { BURN_TABLE } from './burn.js';
import { CUT_TABLE } from './cut.js';
import { PUNCTURE_TABLE } from './puncture.js';
export const WOUND_TABLE_SOURCE = {
    entries: {
        cut: CUT_TABLE,
        puncture: PUNCTURE_TABLE,
        blunt: BLUNT_TABLE,
        burn: BURN_TABLE,
    },
    overlays: [BITE_OVERLAY],
};
export const WOUND_TABLES = WoundTable.from(WOUND_TABLE_SOURCE);
//# sourceMappingURL=index.js.map